import {
  SET_ACTIVE_DROPDOWN,
  SET_BASEMAP,
  SET_SELECTED_ADDRESS_LOCATION,
} from '../actions/general';

const defaultState = {
  activeDropdown: null,
  basemap: 'light',
};

const generalReducer = (state = defaultState, action) => {
  switch (action.type) {
    case SET_ACTIVE_DROPDOWN:
      return {
        ...state,
        activeDropdown: action.payload,
      };
    case SET_SELECTED_ADDRESS_LOCATION:
      return {
        ...state,
        selectedAddressLocation: action.payload,
      };
    case SET_BASEMAP:
      return {
        ...state,
        basemap: action.payload,
      };
    default:
      return state;
  }
};

export default generalReducer;
